<template>
    <div class="menu">
        <div
            class="Industry"
            v-for="(i, index) in tabs"
            :key="index"
            :class="{ active: index == currtpath }"
        >
            <router-link :to="{ path: i.url, query: { id: $route.query.id } }">
                <img
                    v-if="currtpath != i.url"
                    :src="i.img"
                    class="first weui-tabbar__icon"
                />
                <img
                    v-if="currtpath == i.url"
                    :src="i.active"
                    class="last first weui-tabbar__icon"
                />
                <p class="weui-tabbar__label">{{ i.text }}</p>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currtpath: this.$route.path,
            tabs: [
                {
                    text: "产业现状",
                    url: "/industry",
                    img: require("@/assets/image/petrifaction/icon1.png"),
                    active: require("@/assets/image/petrifaction/icon11.png"),
                },
                {
                    text: "投资方向",
                    url: "/investment",
                    img: require("@/assets/image/petrifaction/icon2.png"),
                    active: require("@/assets/image/petrifaction/icon22.png"),
                },
                {
                    text: "项目凝练",
                    url: "/project",
                    img: require("@/assets/image/petrifaction/icon3.png"),
                    active: require("@/assets/image/petrifaction/icon33.png"),
                },
			],
        };
	},
    methods: {},
};
</script>

<style lang="scss" scoped>
.menu {
    -webkit-animation: scale-in-ver-bottom 0.5s
        cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    animation: scale-in-ver-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
        both;
    position: fixed;
    bottom: 0;
    background: #fff;
    width: 100%;
    height: 10%;
    box-shadow: 0px 0px 21px 0px rgba(8, 27, 53, 0.13);
    text-align: center;
    .Industry {
        display: inline-block;
        font-size: 14px;
        color: #999;
        margin: 13px 7% 0;
        img {
            width: 35%;
        }
    }
}
.weui-tabbar__label{
    color: #dca74e;
}
.router-link-active {
    p{
        color: #0976fd;
    }
}
</style>